import users from './users';
import specs from './specs';
import statuses from './statuses';

export default {
  users,
  specs,
  statuses,
};
